import { render, staticRenderFns } from "./SitesHeading.vue?vue&type=template&id=ec5f6b34&"
import script from "./SitesHeading.vue?vue&type=script&lang=js&"
export * from "./SitesHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports